<template>
 <div id="business-data-stage">
  <div class="header mt-5">
   <b class="text-3xl">Prepare seus dados comerciais.</b>
  </div>

  <p class="mt-5 mb-5">Nessa etapa também será possível a criação de um Gerenciador de Negócios.</p>

  <div class="body mt-5">
   <div class="flex">
    <feather-icon icon="FileTextIcon" svgClasses="w-5 h-5" class="p-5"/>
    <p class="align-self-center">Você deve ter em mãos os dados da sua empresa.</p>
    <vx-tooltip text="Verificação da Empresa: Razão Social, Alvará de Funcionamento, Certificado de Registro Fiscal; Verificação do Endereço: Conta de Luz, Extrato Bancário, Alvará de Funcionamento;">
     <feather-icon icon="HelpCircleIcon" svgClasses="w-5 h-5"></feather-icon>
    </vx-tooltip>
   </div>
   <div class="flex">
    <feather-icon icon="Link2Icon" svgClasses="w-5 h-5" class="p-5"/>
    <p class="align-self-center">Você deve ter um site comercial válido. Caso não possua, utilize o seu <a href="" @click.prevent="redirectToInfos"><b>Informações da Loja</b></a>.</p>
   </div>
   <div class="flex">
    <feather-icon icon="AlertTriangleIcon" svgClasses="w-5 h-5" class="p-5"/>
    <p class="align-self-center">É necessário verificar sua conta comercial o mais rápido possível. Uma empresa verificada pode começar com 1.000 conversas ativas/dia. Se não for verificada a sua conta, a Meta pode desativa-la.</p>
   </div>
  </div>
 </div>
</template>

<script>

import {formatRouteTenantPath} from "@/utils";

export default {
 name: 'business-data-stage',
 data() {
  return {}
 },
 methods:{
  redirectToInfos() {
   const route = this.$router.resolve(formatRouteTenantPath('/configs/client-form'));
   window.open(route.href, '_blank')
  }
 }
}

</script>

<style scoped lang="scss">

</style>